import DOMPurify from 'dompurify';
import React from 'react';
import { BodyMediumEmphasized, BodyMediumRegular, YStack } from 'smoothie';

// the email copy we currently send to mailjet isn't technically valid HTML - however most email clients gracefully handle rendering the ordered list as it
// react isn't so nice, so instead of rendering it as is, lets convert it to an object first to make things easier
export const parseHtml = (
    htmlString: string,
): Array<{ title: string; children: string[] }> => {
    const sanitizedHtml = DOMPurify.sanitize(htmlString);
    const parser = new DOMParser();
    const doc = parser.parseFromString(sanitizedHtml, 'text/html');

    const result: Array<{ title: string; children: string[] }> = [];
    const rootOl = doc.querySelector('ol');
    if (!rootOl) return result;

    rootOl.querySelectorAll(':scope > li').forEach((li) => {
        const title = li.textContent?.trim() ?? '';

        // Check if next sibling is a nested <ol>
        const nextSibling = li.nextElementSibling;
        let children: string[] = [];
        if (nextSibling?.tagName === 'OL') {
            children = Array.from(nextSibling.querySelectorAll('li')).map(
                (childLi) => childLi.textContent?.trim() ?? '',
            );
        }

        result.push({ title, children });
    });

    return result;
};

const IncomeSplitHistoryRules = ({ emailCopy }: { emailCopy: string }) => {
    const parsedList = parseHtml(emailCopy);

    return (
        <YStack gap={8}>
            {parsedList.map(({ title, children }, index) => (
                <YStack gap={8} key={index}>
                    <BodyMediumEmphasized>
                        {index + 1}. {title}
                    </BodyMediumEmphasized>
                    <YStack gap={8}>
                        {children.map((child, index) => (
                            <BodyMediumRegular marginLeft={16} key={index}>
                                {String.fromCharCode(97 + index)}. {child}
                            </BodyMediumRegular>
                        ))}
                    </YStack>
                </YStack>
            ))}
        </YStack>
    );
};

export default IncomeSplitHistoryRules;
